<div class="row p-2" *ngIf="alertService.getMessage() !== ''">
  <div class="col-12">
    <ngb-alert [type]="getAlertType()" (closed)="onCloseAlert()">
      {{ alertService.getMessage() }}
    </ngb-alert>
  </div>
</div>
<router-outlet/>
